import AppointmentInfo from "./appointment-info-form";
import AppointmentInfoSummary from "./appointments-info-summary";
import RetirementsInfoForm from "./retirements-info-form";
import RegularizationRetirementsInfoForm from "./regularization-retirements-info-form";
import RetirementsInfoSummary from "./retirements-info-summary";

const formSteps = (isRegularization = false) =>([
  {
    name: "Appointment Info",
    description: "Information about the appointment",
    accessor: "appointmentInfo",
    FormComponent: AppointmentInfo,
    SummaryComponent: AppointmentInfoSummary
  },
  ...(isRegularization ? [
    {
      name: "Meter Retirement Sets Info",
      description: "Information about the meter retirement sets for this batch",
      accessor: "retirementsInfo",
      FormComponent: RegularizationRetirementsInfoForm,
      SummaryComponent: (props: any) =>  <RetirementsInfoSummary {...props} isRegularization />

    },
  ] : [
    {
      name: "Meter Retirement Sets Info",
      description: "Information about the meter retirement sets for this batch",
      accessor: "retirementsInfo",
      FormComponent: RetirementsInfoForm,
      SummaryComponent: RetirementsInfoSummary
    },
  ])
])

export default formSteps;
